module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"display_by_product":"製品により、","search_placeholder":"レビューキーワード検索"}}')
  delete Component.options._Ctor
}
